export default function splitString( str: string, limit = 50) {
  if(str && typeof str === "string"){
    return str.slice(0, limit) + (limit <= str.length ? "..." : "");
  }
  return str; 
}
